import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
  effect,
  Signal,
} from '@angular/core';
import { FeatureFlagService } from '../services/feature-flag.service';

@Directive({
  selector: '[inexpFeatureFlag]',
  standalone: true,
})
export class FeatureFlagDirective {
  private readonly _templateRef = inject(TemplateRef);
  private readonly _viewContainer = inject(ViewContainerRef);
  private readonly _featureFlagsService = inject(FeatureFlagService);

  private _flagSignal: Signal<boolean> | null = null;

  @Input() set inexpFeatureFlag(value: string) {
    if (value) {
      this._flagSignal = this._featureFlagsService.createFlagSignal(value);
    }
  }

  constructor() {
    effect(() => {
      if (!this._flagSignal) return;

      const isEnabled = this._flagSignal();

      this._viewContainer.clear();

      if (isEnabled) {
        this._viewContainer.createEmbeddedView(this._templateRef);
      }
    });
  }
}
